import { renderTaskCard } from "./task-card.js";

export function renderTodayView({ todoTasks, completedTasks, editingTaskId, editingTaskDraft }) {
    return `
        <div class="h-full flex flex-col min-h-0">
            <header class="px-4 py-4 sm:px-6 sm:py-6 lg:px-10 lg:py-8 flex-shrink-0 z-10 bg-white">
                <h1 class="font-display text-4xl sm:text-5xl tracking-tight lowercase">today</h1>
            </header>
            <div class="px-4 pb-4 sm:px-6 sm:pb-5 lg:px-10 lg:pb-6 flex-shrink-0 z-10 bg-white">
                <div class="group flex items-center gap-3 bg-stone-50 rounded-2xl px-5 py-4 border border-stone-200/60 focus-within:border-stone-400 focus-within:bg-white focus-within:shadow-sm transition-all">
                    <svg class="w-5 h-5 text-stone-400 group-focus-within:text-stone-900 transition-colors" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                    <input id="taskInput" type="text" aria-label="add task for today" class="flex-1 bg-transparent border-none outline-none text-[15px] placeholder-stone-400 text-stone-900" placeholder="what needs to be done?">
                </div>
            </div>
            <div class="flex-1 overflow-y-auto px-4 pb-24 sm:px-6 sm:pb-10 lg:px-10 flex flex-col">
                <div class="flex flex-col gap-2">
                    ${
                        todoTasks.length
                            ? todoTasks
                                  .map((task, i) =>
                                      renderTaskCard(task, {
                                          index: i,
                                          listId: "today-todo",
                                          editingDraft: editingTaskId === task.id ? editingTaskDraft : null,
                                      }),
                                  )
                                  .join("")
                            : '<div class="rounded-3xl border border-dashed border-stone-300 bg-stone-50/70 p-6 text-[14px] text-stone-500 lowercase">No overdue or due-today tasks right now.</div>'
                    }
                </div>
                ${completedTasks.length ? `
                <details class="mt-8" open>
                    <summary class="flex items-center gap-4 mb-3 cursor-pointer select-none list-none [&::-webkit-details-marker]:hidden">
                        <h2 class="text-[11px] font-medium text-stone-400 lowercase tracking-widest flex-shrink-0">completed (${completedTasks.length})</h2>
                        <div class="h-px bg-stone-100 flex-1"></div>
                        <svg class="w-3.5 h-3.5 text-stone-300 transition-transform details-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>
                    </summary>
                    <div class="flex flex-col gap-1">
                        ${completedTasks
                              .map((task, i) =>
                                  renderTaskCard(task, {
                                      index: i,
                                      listId: "today-completed",
                                      editingDraft: editingTaskId === task.id ? editingTaskDraft : null,
                                  }),
                              )
                              .join("")}
                    </div>
                </details>
                ` : ''}
            </div>
        </div>
    `;
}
